export enum Versions {
  One = 1,
  Two = 2,
  All = One | Two,
}
